<template>
  <OrganismReturnTo/>
</template>

<script>
export default {
  name: 'ReturnTo',

  components: {
    OrganismReturnTo: () => import('@/components/organisms/OrganismReturnTo')
  },

  mounted () {
    if (this.$route.query.academy) {
      window.location.replace(this.$route.query.academy)
    } else {
      window.location.replace('https://vidroop.com')
    }
  }
}
</script>
